import type { ViewerShell } from '../shell';

/**
 * " No apto para uso diagnóstico " banner (IMEXHS `diagnosticWarning`, spec section 1.4 / 7):
 * shown across the top of the viewer when the deployment says the viewer is not cleared for
 * diagnosis. Off unless `diagnosticWarning: true` in viewer_config.js.
 */
export const DIAGNOSTIC_WARNING = ' No apto para uso diagnóstico ';

export function install(shell: ViewerShell): void {
  if (shell.config.diagnosticWarning !== true) return;
  const banner = document.createElement('div');
  banner.className = 'diagnostic-warning';
  banner.setAttribute('role', 'alert');
  banner.textContent = DIAGNOSTIC_WARNING;
  shell.regions.topNav.before(banner);
}
